import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch, matchPath } from "react-router-dom";
import InteractiveScriptPlayGround from '../components/pages/IS/index'
import SnapshotCanvas from '../components/pages/IS/snapshot/SnapshotCanvas'
import ScriptBuilder from '../pages/scriptbuilder/main'
// import Projects from '../pages/project/main'

const ScriptBuilderRouter = (props) => {
    const { path } = props.match
    const customProps = {
        ...props,
        modulePath: path
    }

    return <Switch>
        <Route exact path={`${path}`}
        render={() => <ScriptBuilder {...customProps} />}
        />

        {/* Read-only view of one snapshot. Declared before /:id so the longer
            path wins, and kept on its own route so it gets the full screen and
            its own browser tab. */}
        <Route exact path={`${path}/:id/snapshot/:version`}
        render={(routeProps) => <SnapshotCanvas {...customProps} {...routeProps} />}
        />

        <Route exact path={`${path}/:id`}
        render={() => <InteractiveScriptPlayGround {...customProps} />}
        />

        {/* if there is no route match then redirect to the root path */}
        <Route render={() => <Redirect to="/" />} />
    </Switch>
}

export default ScriptBuilderRouter